module.exports = __webpack_public_path__ + "img/trustpilot-logo.5b494a8c.svg";